import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UserState {
  dialogVisible: boolean;

  actions: {
    setDialogVisible: (mapCenter: UserState['dialogVisible']) => void;
  };
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      dialogVisible: true,

      actions: {
        setDialogVisible: (dialogVisible) => set({ dialogVisible }),
      },
    }),
    {
      name: 'vielmobil.info/user',
      version: 2,
      partialize: ({ actions, ...rest }) => rest,
    },
  ),
);
